import { googleMapsApiKey } from "../../../services/config";
import { bigDataLocationApiKey } from "../../../services/config";
import { SET_COMPANY } from "../../company/store/mutation-type";
import services from "../services";
import * as types from "./mutation-type";

export const ActionSetLocation = ({ commit }, payload) => {
    commit(types.SET_LOCATION, payload)
}

export const ActionSetStreetName = ({ commit }, payload) => {
    commit(types.SET_STREET_NAME, payload)
}

export const ActionSetStreetNumber = ({ commit }, payload) => {
    commit(types.SET_STREET_NUMBER, payload)
}

export const ActionSetNeighborhood = ({ commit }, payload) => {
    commit(types.SET_NEIGHBORHOOD, payload)
}

export const ActionSetPostalCode = ({ commit }, payload) => {
    commit(types.SET_POSTAL_CODE, payload)
}

export const ActionSetCity = ({ commit }, payload) => {
    commit(types.SET_CITY, payload)
}

export const ActionSetUf = ({ commit }, payload) => {
    commit(types.SET_UF, payload)
}

export const ActionSetCountry = ({ commit }, payload) => {
    commit(types.SET_COUNTRY, payload)
}

export const ActionSetLatitude = ({ commit }, payload) => {
    commit(types.SET_LATITUDE, payload)
}

export const ActionSetLongitude = ({ commit }, payload) => {
    commit(types.SET_LONGITUDE, payload)
}

export const ActionSetUserId = ({ commit }, payload) => {
    commit(types.SET_USER_ID, payload)
}

export const ActionGetLocation = ({ dispatch }, payload) => {
    return new Promise(async(resolve, reject) => {
        const resp = await services.getLocation(payload)
        let coords = resp.data.loc.split(',')
        try {
            dispatch("ActionSetLocation", true)
            dispatch("ActionSetLatitude", coords[0])
            dispatch("ActionSetLongitude", coords[1])
            dispatch("ActionGetAddress")
            resolve(resp.data)
        } catch (error) {
            reject(resp.data)
        }

    })
};

export const ActionGetAccessLocation = ({dispatch, getters}) => {
    if (navigator.geolocation) {
        navigator.geolocation.watchPosition(
            position => {
                if(!getters.getSavedLocation) {
                    dispatch("ActionSetLocation", true)
                    dispatch("ActionSetLatitude", position.coords.latitude)
                    dispatch("ActionSetLongitude", position.coords.longitude)
                    dispatch("ActionGetAddress")
                }
            },
            error => {
                let accepted = JSON.parse(sessionStorage.getItem('accepted'))
                if(getters.getSavedLocation || accepted) {
                    return
                }
                dispatch("ActionSetLocation", false)
                sessionStorage.setItem('accepted', false)
            },
            {
                timeout: 5000,
            }
        )
    }
}

export const ActionGetAddress = async ({state, dispatch}) => {
    if(!state.location) {
        return
    }
    const APP_KEY = googleMapsApiKey
    let url_api = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${state.latitude},${state.longitude}&key=${APP_KEY}`
    await fetch(url_api)
    .then(response => response.json())
    .then((response) => {
        if(!response.results) {
            return
        }
        if(!Object.entries(response.results).length) {
            return
        }
        var address = response.results[0].formatted_address
        address = address.split(',')
        let numero_bairro = address[1].split('-')
        let cidade_estado = address[2].split('-')
        dispatch("ActionSetStreetName", address[0] ?? '')
        dispatch("ActionSetStreetNumber", numero_bairro[0] ?? '')
        dispatch("ActionSetNeighborhood", numero_bairro[1] ?? '')
        dispatch("ActionSetPostalCode", address[3] ?? '')
        dispatch("ActionSetCity", cidade_estado[0] ?? '')
        dispatch("ActionSetUf", cidade_estado[1] ?? '')
        dispatch("ActionSetCountry", address[4] ?? '')
        dispatch("ActionSaveAccessLocation")
    })
    .catch((error) => {
        console.log(error)
    })
}

export const ActionSaveAccessLocation = ({state}) => {
    return new Promise(async(resolve, reject) => {
        let info = {
            location: state.location,
            street_name: state.street_name,
            street_number: state.street_number,
            neighborhood: state.neighborhood,
            postal_code: state.postal_code,
            city: state.city,
            uf: state.uf,
            country: state.country,
            latitude: state.latitude,
            longitude: state.longitude,
            user_id : state.user_id
        }
        const { data } = await services.saveAccessLocation(info)
        if(data.error === false) {
            sessionStorage.setItem("accepted", true);
            resolve(data)
        }
        reject(data)
    })
}

export const  actionCheckAccessLocation = ({dispatch}) => {
    navigator.permissions.query({name:'geolocation'}).then(function(permissionStatus) {
        if(permissionStatus.state == 'granted') {
            dispatch("ActionSetLocation", true)
        }else{
            sessionStorage.setItem('accepted', false)
            dispatch("ActionSetLocation", false)
        }
        permissionStatus.onchange = function() {
            if(this.state == 'granted') {
                dispatch("ActionSetLocation", true)
            }else{
                sessionStorage.setItem('accepted', false)
                dispatch("ActionSetLocation", false)
            }
        };
    });
}
